export default __webpack_public_path__ + "static/menu-73250c9d9ce15ed67dfa2de09419ea34.png";